<div class="file-upload">
    <kendo-upload
        [saveUrl]="uploadSaveUrl"
        [removeUrl]="uploadRemoveUrl"
        [multiple]="multipleFile"
        [restrictions]="fileRestrictions"
        (select)="selectEventHandler($event)"
        (complete)="uploadCleanUp()"
    >
    </kendo-upload>
    <span class="docTypeErrorMessage">
        {{ this.errorMessage }}
    </span>
</div>